import { render } from "./tabNavigation.vue?vue&type=template&id=34652856&scoped=true&ts=true"
import script from "./tabNavigation.vue?vue&type=script&lang=ts"
export * from "./tabNavigation.vue?vue&type=script&lang=ts"

import "./tabNavigation.vue?vue&type=style&index=0&id=34652856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34652856"]])

export default __exports__